// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"d1eab4b4cb47520462c5","293":"1bf4078c678bb1651577","522":"b9053567b4d33c7d3591"}[chunkId] + ".js";
};